export default __webpack_public_path__ + "static/media/Perfection Varnishe Fernissa.56ccf28c.jpg";